import {
  Flexbox,
  Form,
  ListManager,
  PageHeader,
  Paginator,
  QuickFilter,
  Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterCastrations from '../../components/FilterCastrations'
import CardItem from './CardItem'

function CastrationsRejectedAndCanceled({ title }) {
  usePageTitle({ title })

  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.castrationsRejectedAndCanceled,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Castrações rejeitadas e canceladas"
        subtitle="Quantidade de castrações rejeitadas e canceladas"
        icon="fas fa-hourglass-half"
        rightAction={() => <FilterCastrations />}
      />
      <QuickFilter
        initialValues={{ onlyYear: '' }}
        title="Filtrar meus pets"
        renderForm={() => (
          <Form.Group>
            <Form.Switch
              className="form-switch"
              key="onlyYear"
              style={{ marginTop: 50, marginLeft: 20 }}
            >
              <Form.ValidationField
                type="checkbox"
                name="onlyYear"
                id="onlyYear"
              />
              <i className="form-icon" />
              &nbsp;Ver relatório por ano
            </Form.Switch>
          </Form.Group>
        )}
      />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <Flexbox.Columns>
              <Flexbox.Column className="col-6 col-sm-12 my-2">
                <CardItem
                  item={data?.totalStatus}
                  statusList={data?.statusList}
                />
              </Flexbox.Column>
              {data.rows.map((item) => (
                <Flexbox.Column
                  key={item?.month || item?.year}
                  className="col-6 col-sm-12 my-2"
                >
                  <CardItem item={item} statusList={data?.statusList} />
                </Flexbox.Column>
              ))}
            </Flexbox.Columns>
            {Boolean(data) && (
              <div className="my-2">
                <Paginator paginatedList={data} />
              </div>
            )}
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default CastrationsRejectedAndCanceled
